export var ShimmerVariants;
(function (ShimmerVariants) {
    ShimmerVariants["linear"] = "linear";
    ShimmerVariants["square"] = "square";
})(ShimmerVariants || (ShimmerVariants = {}));
//# sourceMappingURL=constants.js.map